var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSendChat = function SvgSendChat(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 28 27"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M14.001 26.833c7.352 0 13.334-5.981 13.334-13.333S21.353.167 14 .167.668 6.147.668 13.5s5.981 13.333 13.333 13.333m0-20 6.667 6.667h-5.333v6.666h-2.667V13.5H7.335z"
  })));
};
export default SvgSendChat;